// components/SuperAdminLayout.js
import React, { useEffect, useState } from "react";
import AdminSidebar from "./AdminSidebar";
import { Outlet, useLocation } from "react-router-dom";
import TopBar from "../components/TopBar";

const AdminLayout = () => {
  // Load from localStorage if available, otherwise default to false
  const [sidebarExpanded, setSidebarExpanded] = useState(() => {
    const storedState = localStorage.getItem("sidebarExpanded");
    return storedState ? JSON.parse(storedState) : false;
  });

  const location = useLocation();

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // 👇 Always close sidebar on mobile
        setSidebarExpanded(false);
      }
    };

    // Run once on mount
    handleResize();

    // Watch for window resizing
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Persist sidebar state only if desktop
  useEffect(() => {
    if (window.innerWidth > 768) {
      localStorage.setItem("sidebarExpanded", JSON.stringify(sidebarExpanded));
    }
  }, [sidebarExpanded]);

  return (
    <div className="app">
      <AdminSidebar
        expanded={sidebarExpanded}
        toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
      />
      <div
        className={`main-content-wrapper ${
          sidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <nav className="topbar-wrapper">
          <TopBar
            toggleSidebar={() => setSidebarExpanded(!sidebarExpanded)}
            sidebarExpanded={sidebarExpanded}
          />
        </nav>
        <main className="page-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
